import styled, { keyframes } from "styled-components";

export const PageContainer = styled.div`
  padding: 24px;
  min-height: calc(100vh - 64px);
  max-width: 1200px;
  margin: 0 auto;
  overflow-x: hidden;

  @media (max-width: 1024px) {
    padding: 16px;
  }

  @media (max-width: 767px) {
    padding: 12px;
  }

  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #4a5568;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
  }

  @media (max-width: 767px) {
    justify-content: center;
    margin-bottom: 16px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 30px;
  font-weight: 400;
  color: #5a5a5a;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

export const FormContainer = styled.div``;

// Photo Upload Components
export const PhotoUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 16px;
`;

export const PhotoUploadButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 200px;
  height: 150px;
  border: 2px dashed #e39435;
  color: #e39435;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background: #f7fafc;

  &:hover {
    border-color: #76b041;
    color: #76b041;
    background: #f0fff4;
  }

  input[type="file"] {
    display: none;
  }

  label {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
  }

  img {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 120px;
  }
`;

export const PhotoPreview = styled.div`
  position: relative;
  width: 200px;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e2e8f0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 120px;
  }
`;

// Menu Items Components
export const MenuItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const MenuItemCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  transition: box-shadow 0.2s;
  max-width: 680px;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1024px) {
    padding: 14px;
    gap: 14px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    text-align: center;
    gap: 12px;
    padding: 12px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    gap: 10px;
  }
`;

export const MenuItemImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    width: 80px;
    height: 80px;
  }
`;

export const MenuItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MenuItemName = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
`;

export const MenuItemPrice = styled.span`
  font-size: 14px;
  color: #76b041;
  font-weight: 500;
`;

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const QuantityButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  img {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 767px) {
    width: 44px;
    height: 44px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
  }
`;

export const QuantityDisplay = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  min-width: 24px;
  text-align: center;
`;

export const RemoveItemButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  border: 1px solid #e2e2e2;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 8px;
  img {
    width: 16px;
    height: 16px;
  }
`;

export const AddMenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #e39435;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 12px;
  box-shadow: 0 2px 4px rgba(227, 148, 53, 0.2);

  &:hover {
    background: #d97706;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(227, 148, 53, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  img {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 1024px) {
    padding: 16px 24px;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 16px 24px;
    font-size: 16px;
    margin-top: 16px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 480px) {
    padding: 14px 20px;
    font-size: 15px;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 32px;

  @media (max-width: 767px) {
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    margin-bottom: 16px;
    flex-direction: column;
  }
`;

export const FormLabel = styled.label`
  font-size: 16px;
  font-weight: 700;
  color: #e39435;
  width: 30%;
  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 8px;
  }

  @media (max-width: 1279px) and (min-width: 768px) {
    width: 30%;
  }
`;

export const DropDownContainer = styled.div<{ hasError?: boolean }>`
  width: 70%;
  max-width: 680px;
  @media (max-width: 767px) {
    width: 100%;
  }
  @media (max-width: 1279px) and (min-width: 768px) {
    width: 70%;
  }
`;

export const FormInput = styled.input<{ $hasError?: boolean; $width?: number; $specialCharNotAllowed?: boolean  }>`
  padding: 12px 16px;
  border: 1px solid ${(props) => (props.$hasError ? "#e53e3e" : "#E39435")};
  border-radius: 6px;
  font-size: 16px;
  color: #1e2f23;
  background: white;
  transition: border-color 0.2s;
  box-sizing: border-box;
  width: 100%;
  max-width: ${(props) => (props.$width ? props.$width + "px" : "70%")};
  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? "#e53e3e" : "#E39435")};
    box-shadow: 0 0 0 2px rgba(227, 148, 53, 0.2);
  }

  &::placeholder {
    color: #b0b0b0;
  }

  @media (max-width: 767px) {
    font-size: 16px;
    padding: 14px 16px;
  }

  @media (max-width: 480px) {
    padding: 12px 14px;
  }
`;

export const FormSelect = styled.select<{ hasError?: boolean }>`
  padding: 12px 16px;
  border: 2px solid ${(props) => (props.hasError ? "#e53e3e" : "#e2e8f0")};
  border-radius: 6px;
  font-size: 14px;
  color: #2d3748;
  background: white;
  transition: border-color 0.2s;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.hasError ? "#e53e3e" : "#76b041")};
  }
`;

export const FormTextArea = styled.textarea<{ hasError?: boolean }>`
  padding: 12px 16px;
  border: 2px solid ${(props) => (props.hasError ? "#e53e3e" : "#e2e8f0")};
  border-radius: 6px;
  font-size: 14px;
  color: #2d3748;
  background: white;
  transition: border-color 0.2s;
  resize: vertical;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.hasError ? "#e53e3e" : "#76b041")};
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

export const ItemRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto auto;
  gap: 16px;
  align-items: end;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ItemInput = styled.input<{ hasError?: boolean }>`
  padding: 10px 12px;
  border: 2px solid ${(props) => (props.hasError ? "#e53e3e" : "#e2e8f0")};
  border-radius: 6px;
  font-size: 14px;
  color: #2d3748;
  background: white;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.hasError ? "#e53e3e" : "#76b041")};
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

export const AddItemButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #e39435;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 16px;

  &:hover {
    background: #d68929;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  gap: 16px;
  margin-top: 16px;
  padding-top: 24px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const SaveButton = styled.button<{ disabled?: boolean }>`
  background: ${(props) => (props.disabled ? "#a0aec0" : "#76b041")};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;
  min-width: 150px;
  margin-top: 24px;
  box-shadow: 0 2px 4px rgba(118, 176, 65, 0.2);

  &:hover {
    background: ${(props) => (props.disabled ? "#a0aec0" : "#68a235")};
    transform: ${(props) => (props.disabled ? "none" : "translateY(-1px)")};
    box-shadow: ${(props) =>
      props.disabled ? "none" : "0 4px 8px rgba(118, 176, 65, 0.3)"};
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 1024px) {
    padding: 16px 32px;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 16px 24px;
    font-size: 18px;
    margin-top: 32px;
  }

  @media (max-width: 480px) {
    padding: 14px 20px;
    font-size: 16px;
  }
`;

export const CancelButton = styled.button`
  background: transparent;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 150px;

  &:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 14px 32px;
  }
`;

// Loading and Message Components
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const LoadingSpinner = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingSpinnerIcon = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #76b041;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const ErrorMessageTitle = styled.div`
  background: #fed7d7;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  margin-top: 8px;
  border: 1px solid #feb2b2;
  line-height: 1.4;

  @media (max-width: 767px) {
    font-size: 15px;
    padding: 14px 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 12px 14px;
  }
`;

export const ErrorMessage = styled.div`
  color: #c53030;
  font-size: 14px;
`;

export const SuccessMessage = styled.div`
  background: #c6f6d5;
  color: #276749;
  padding: 16px 20px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 24px;
  border: 1px solid #9ae6b4;
  font-weight: 600;
`;

// Responsive width container
export const ResponsiveContainer = styled.div`
  width: 70%;
  max-width: 680px;
  @media (max-width: 767px) {
    width: 100%;
  }
  @media (max-width: 1279px) and (min-width: 768px) {
    width: 70%;
  }
`;

export const ResponsiveButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

// Review Modal Components
export const ReviewModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
`;

export const ReviewModalContent = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }
`;

export const ReviewModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 24px;
`;

export const ReviewModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 20px;
  }
`;

export const ReviewModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #a0aec0;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s;

  &:hover {
    color: #4a5568;
  }
`;

export const ReviewModalBody = styled.div`
  padding: 0 24px 24px 24px;
`;

export const ReviewSection = styled.div`
  margin-bottom: 24px;
`;

export const ReviewSectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const ReviewImageContainer = styled.div`
  width: 120px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  margin-bottom: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    width: 100px;
    height: 75px;
  }
`;

export const ReviewImagePlaceholder = styled.div`
  width: 120px;
  height: 90px;
  border-radius: 8px;
  border: 2px dashed #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
  font-size: 14px;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    width: 100px;
    height: 75px;
    font-size: 12px;
  }
`;

export const ReviewDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f7fafc;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const ReviewDetailLabel = styled.span`
  font-weight: 600;
  color: #4a5568;
  font-size: 14px;
`;

export const ReviewDetailValue = styled.span`
  color: #2d3748;
  font-size: 14px;
  font-weight: 500;
text-align:right;
  &.price {
    color: #76b041;
    font-weight: 600;
  }
`;

export const ReviewItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ReviewItemCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  @media (max-width: 767px) {
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }
`;

export const ReviewItemImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    width: 60px;
    height: 60px;
  }
`;

export const ReviewItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ReviewItemName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
`;

export const ReviewItemPrice = styled.span`
  font-size: 13px;
  color: #76b041;
  font-weight: 500;
`;

export const ReviewItemQuantity = styled.span`
  font-size: 14px;
  color: #4a5568;
  font-weight: 600;
  background: white;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  min-width: 40px;
  text-align: center;
`;

export const ReviewModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const ReviewModalButton = styled.button<{
  variant?: "primary" | "secondary";
}>`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  min-width: 120px;

  ${(props) =>
    props.variant === "primary"
      ? `
    background: #76b041;
    color: white;
    
    &:disabled {
      background: #a0aec0;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  `
      : `
    background: transparent;
    color: #4a5568;
    border: 2px solid #e2e8f0;
    
    &:hover {
      background: #f7fafc;
      border-color: #cbd5e0;
    }
  `}

  @media (max-width: 767px) {
    width: 100%;
    padding: 14px 24px;
    font-size: 16px;
  }
`;

export const ReviewLoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-right: 8px;
`;

// Helper Text Components
export const HelpIconContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const HelperTextPopup = styled.div<{ $visible: boolean }>`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 300px;
  max-width: 400px;
  font-size: 14px;
  color: #4a5568;
  line-height: 1.4;
  margin-top: 8px;
  display: ${(props) => (props.$visible ? "block" : "none")};

  &::before {
    content: "";
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid white;
  }

  &::after {
    content: "";
    position: absolute;
    top: -7px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #e2e8f0;
  }

  @media (max-width: 767px) {
    min-width: 250px;
    max-width: 300px;
    font-size: 13px;
    padding: 10px 14px;
  }
`;

export const HelperTextContent = styled.div`
  font-weight: 500;

  .highlight {
    color: #e39435;
    font-weight: 600;
  }
`;
